import script from "./MenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./MenuItem.vue?vue&type=style&index=0&id=75ee7b88&lang=scss"

const __exports__ = script;

export default __exports__